import * as React from 'react';
import { useRouter } from 'next/router';

import { noop } from '../misc';

type PageTransitionHandler = (url: string) => void;

export type PageTransitionHandlers = {
  start?: PageTransitionHandler;
  complete?: PageTransitionHandler;
  error?: PageTransitionHandler;
};

export function usePageTransition(handlers: PageTransitionHandlers) {
  const router = useRouter();
  const { start = noop, complete = noop, error = noop } = handlers;

  React.useEffect(() => {
    router.events.on('routeChangeStart', start);
    router.events.on('routeChangeComplete', complete);
    router.events.on('routeChangeError', error);

    return () => {
      router.events.off('routeChangeStart', start);
      router.events.off('routeChangeComplete', complete);
      router.events.off('routeChangeError', error);
    };
  });
}
